import { Bot } from "lucide-react";
import { theme } from "../../../theme";

type EmptyThreadStateProps = {
  suggestions: string[];
  onSuggestionClick: (question: string) => void;
  providerDescription?: string;
};

export const EmptyThreadState = ({
  suggestions,
  onSuggestionClick,
  providerDescription,
}: EmptyThreadStateProps) => {
  return (
    <div
      className={`flex flex-col items-center justify-center h-full min-h-[300px] px-4 py-8 ${theme.anim.fadeInUp}`}
    >
      {/* Bot avatar */}
      <div className="relative mb-5">
        <div className="w-16 h-16 rounded-2xl dark:bg-sy-teal/[0.12] bg-teal-50 dark:border-sy-teal/[0.20] border border-teal-100 flex items-center justify-center">
          <Bot className="w-8 h-8 dark:text-sy-teal text-teal-600" />
        </div>
        {/* Online indicator */}
        <div className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full bg-sy-green border-2 dark:border-sy-navy border-white flex items-center justify-center">
          <div className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
        </div>
      </div>

      <h2 className={`text-xl font-bold ${theme.text.heading} mb-2 text-center`}>Ask Charlie</h2>
      <p className={`${theme.text.body} text-sm text-center max-w-xs leading-relaxed mb-1`}>
        Concussion management, sideline assessment, and return-to-play guidance — grounded in CRT6
        and AIS guidelines.
      </p>

      {providerDescription && (
        <p className={`text-xs ${theme.text.muted} mb-6 text-center`}>{providerDescription}</p>
      )}

      {!providerDescription && <div className="mb-6" />}

      {/* Suggested questions */}
      <div className="flex flex-wrap justify-center gap-2 max-w-sm">
        {suggestions.map((question) => (
          <button
            key={question}
            onClick={() => onSuggestionClick(question)}
            aria-label={`Ask: ${question}`}
            className={`${theme.button.pillBase} ${theme.button.pillTeal}`}
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  );
};
